"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _events = require("../../../analytics/events");
var styles = {
  "add-version": "AddVersionAction__add-version__be3vk",
  "addVersion": "AddVersionAction__add-version__be3vk",
  "button": "AddVersionAction__button__12gnN"
}; 
require('./AddVersionAction.css');
var buttonStyles = _Button.default.themes.DefaultTheme;
var AddVersionAction = function AddVersionAction(props) {
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var asset = props.asset;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.addVersion
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    role: "button",
    className: (0, _classnames.default)(buttonStyles.button, buttonStyles.secondary, buttonStyles.md, styles.button),
    "data-test-id": "add-version-action-link",
    to: getPath('newVersion', asset),
    onClick: function onClick() {
      return trackEvent(_events.EVENT_TYPES.NEW_VERSION_ADDED, (0, _events.assetProperties)(props));
    }
  }, "Add version"));
};
var _default = exports.default = AddVersionAction;
//# sourceMappingURL=AddVersionAction.js.map